import { useEffect } from "react";
import AppState from "./context/AppState";

//components
import AppRouter from "./router/router";

const App = () => {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "Behamrah");
    console.log(localStorage.getItem("hrm-theme"));
    if (localStorage.getItem("hrm-theme") == "dark-theme") {
      localStorage.setItem("dark-toast-bg-color", "#132c4b");
      localStorage.setItem("dark-toast-font-color", "#fff");
      document.body.className = "dark-theme";
    } else {
      localStorage.setItem("dark-toast-bg-color", "#fff");
      localStorage.setItem("dark-toast-font-color", "#132c4b");
      document.body.className = "light-theme";
    }
  }, []);

  return (
    <AppState>
      <div className="w-100">
        <AppRouter />
      </div>
    </AppState>
  );
};

export default App;
